import React from 'react';
import { Tag } from 'udesk-ui';

export const ScoringRulesAbbreviatedList = React.memo((props: any) => {
    // const locales = Locales['current'];
    const { value } = props;

    return (
        <div>
            {value.map((item) => (
                <Tag color={item.operator === 1 ? 'blue' : 'red'} style={{ marginBottom: 4 }}>{`${
                    item.name
                } ${item.operator === 1 ? '+' : '-'}${item.score}`}</Tag>
            ))}
        </div>
    );
});
